import React, { useEffect, useMemo, useState } from "react";
import { Layout, Card, Button, Input, Radio, Popconfirm, Form, message } from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useSelector } from "react-redux";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";

const ManualData = () => {
  const [open, setOpen] = useState(false); 
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [refetch2, setRefetch2] = useState(false);
  const [refetch3, setRefetch3] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  const showDrawer2 = () => {
    setOpen2(true);
  };

  const onClose2 = () => {
    setOpen2(false);
  };
  const showDrawer3 = () => {
    setOpen3(true);
  };

  const onClose3 = () => {
    setOpen3(false);
  };
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color);
  const { isdarkMode } = mode;

  const [externalEnergySources, setExternalEnergySources] = useState([]);
  const [updateExternalEnergySources, setUpdateExternalEnergySources] =
    useState([]);
  const [productionData, setProductionData] = useState([]);
  const [resourceDetails, setResourceDetails] = useState([]);

  const [newExternalSource, setNewExternalSource] = useState("");
  const [newProductionData, setNewProductionData] = useState("");
  const [newResourceDetail, setNewResourceDetail] = useState("");
  const [form] = Form.useForm();
const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };
  const onFinish = (values) => {
    //console.log(values)
    // values = { externalSource: "...", costPerUnit: "..." }
    handleAddExternalEnergy(values);
    form.resetFields();
  };

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_EXTERNAL_ENERGY_SOURCE}`,
    }).then((res) => {
      //console.log(res);
      function addIsUpdateFlag(sourceArray) {
        return sourceArray.map((item) => ({
          ...item,
          // isUpdate: false,
        }));
      }

      if (res) {
        const updatedSources = addIsUpdateFlag(res); // originalSources is your input array
        //console.log(updatedSources);

        setExternalEnergySources(updatedSources);
        setUpdateExternalEnergySources(updatedSources);
      }
    });
  }, [refetch]);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_PRODUCTION_DATA}`,
    }).then((res) => {
      //console.log(res);
      if (res) {
        setProductionData(res);
      }
    });
  }, [refetch2]);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_EMISSION_DATA}`,
    }).then((res) => {
      //console.log(res);
      if (res) {
        setResourceDetails(res);
      }
    });
  }, [refetch3]);

  const handleRadioChange = (data, field) => {
    const { sno, ...rest } = data;
    const updatedRow = {
      ...rest,
      rE_ThirdParty: false,
      rE_Plant: false,
      rE_Utility: false,
      [field]: true, // Only this becomes true
    };

    //console.log("Checkbox clicked:", updatedRow);
    //console.log(data);
    setTimeout(() => {
      insertExternalEnergy(updatedRow);
    }, 2000);
  };

  const deleteExternalEnergy = (data) => {
    //console.log(data);
    makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_EXTERNAL_ENERGY_SOURCE}?SourceID=${data?.sourceID}`,
    }).then((res) => {
      //console.log("Master details :", res);
      setRefetch(!refetch);
      if (res && res.length > 0) {
        // setFlowSectionList(res);
      }
    });
  };
  const deleteEmissionData = (data) => {
    //console.log(data);
    makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_EMISSION_DATA}?EmissionDetailID=${data?.emissionDetailID}`,
    }).then((res) => {
      //console.log("Master details :", res);
      setRefetch3(!refetch3);
      if (res && res.length > 0) {
        // setFlowSectionList(res);
      }
    });
  };
  const deleteProductionData = (data) => {
    //console.log(data);
    makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_PRODUCTION_DATA}?ProductionDataID=${data?.productionDataID}`,
    }).then((res) => {
      //console.log("Master details :", res);
      setRefetch2(!refetch2);
      if (res && res.length > 0) {
        // setFlowSectionList(res);
      }
    });
  };
  const insertExternalEnergy = (data) => {
    //console.log(updateExternalEnergySources);
    //console.log(data);
    const body = updateExternalEnergySources.filter(
      (item) => item.sourceID === data.sourceID
    );
    //console.log(body);
    makeRequest({
      type: APIConstants.POST,
      url: body.length
        ? APIConstants.UPDATE_EXTERNAL_ENERGY_SOURCE
        : APIConstants.INSERT_EXTERNAL_ENERGY_SOURCE,
      body: data,
    }).then((res) => {
      //console.log("Master details :", res);
      setRefetch(!refetch);
      body.length?
      handleNotification(res?.message||"Successfully Updated", "success"):handleNotification(res?.message|| "SuccessFully Inserted", "success");
      if (res && res.length > 0) {
        // setFlowSectionList(res);
      }
    });
  };
  const insertProductionData = (data) => {
    //console.log(data);
    makeRequest({
      type: APIConstants.POST,
      url: APIConstants.INSERT_PRODUCTION_DATA,
      body: data,
    }).then((res) => {
      //console.log("Master details :", res);
      setRefetch2(!refetch2);
      if (res && res.length > 0) {
        // setFlowSectionList(res);
      }
    });
  };
  const insertEmissionData = (data) => {
    //console.log(data);
    makeRequest({
      type: APIConstants.POST,
      url: APIConstants.INSERT_EMISSION_DATA,
      body: data,
    }).then((res) => {
      //console.log("Master details :", res);
      setRefetch3(!refetch3);
      if (res && res.length > 0) {
        // setFlowSectionList(res);
      }
    });
  };
  const externalEnergyCols = [
    { headerName: "S.No", field: "sourceID", width: 80 },
    {
      headerName: "External Energy Source",
      field: "sourceName",
      flex: 1,
      minWidth: 150,
    },
    { headerName: "Cost per unit", field: "costPerUnit", width: 150,editable:true },
    {
      headerName: "RE: 3rd Party",
      field: "rE_ThirdParty",
      width: 120,
      cellRenderer: (params) => (
        <Radio
          checked={params.data.rE_ThirdParty}
          onClick={() => {
            const updatedData = {
              ...params.data,
              rE_ThirdParty: true,
              rE_Plant: false,
              rE_Utility: false,
            };
            params.node.setData(updatedData);
            handleRadioChange(updatedData, "rE_ThirdParty");
          }}
        />
      ),
    },
    {
      headerName: "RE: Plant",
      field: "rE_Plant",
      width: 100,
      cellRenderer: (params) => (
        <Radio
          checked={params.data.rE_Plant}
          onClick={() => {
            const updatedData = {
              ...params.data,
              rE_ThirdParty: false,
              rE_Plant: true,
              rE_Utility: false,
            };
            params.node.setData(updatedData);
            handleRadioChange(updatedData, "rE_Plant");
          }}
        />
      ),
    },
    {
      headerName: "Utility",
      field: "rE_Utility",
      width: 100,
      cellRenderer: (params) => (
        <Radio
          checked={params.data.rE_Utility}
          onClick={() => {
            const updatedData = {
              ...params.data,
              rE_ThirdParty: false,
              rE_Plant: false,
              rE_Utility: true,
            };
            params.node.setData(updatedData);
            handleRadioChange(updatedData, "rE_Utility");
          }}
        />
      ),
    },

    {
      headerName: "Actions",
      width: 100,
      cellRenderer: (params) => (
        <div className="space-x-2">
          <Popconfirm
            title="Are you sure to delete ?"
            icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            onConfirm={() => deleteExternalEnergy(params.data)}
            trigger="click"
          >
            <span
              className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400"
            >
              <DeleteOutlined />
            </span>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const productionCols = [
    { headerName: "S.No", field: "productionDataID", width: 80 },
    { headerName: "Production Data", field: "productionDataName", flex: 1,minWidth:200 },
    {
      headerName: "Actions",
      width: 100,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}

            <Popconfirm
              title="Are you sure to delete ?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteProductionData(params.data)}
              trigger="click"
            >
              <span
                className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400"
              >
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const resourceCols = [
    { headerName: "S.No", field: "emissionDetailID", width: 80 },
    { headerName: "Resource Details", field: "emissionDetailName", flex: 1,minWidth:200  },
    {
      headerName: "Actions",
      width: 100,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}

            <Popconfirm
              title="Are you sure to delete ?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteEmissionData(params.data)}
              trigger="click"
            >
              <span
                className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400"
              >
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const handleAddExternalEnergy = (values) => {
    //console.log(values)
    //console.log(newExternalSource);
    const newData = {
      sourceID: externalEnergySources.length + 1,
      sourceName: values.externalSource,
      costPerUnit:values.costPerUnit
    };
    setExternalEnergySources([newData, ...externalEnergySources]);
    setNewExternalSource("");
    onClose();
  };

  const handleAddProductionData = () => {
    const newData = {
      sno: productionData.length + 1,
      name: newProductionData,
    };
    // setProductionData([...productionData, newData]);
    setNewProductionData("");
    //console.log(newData);
    const { sno, name } = newData;
    const updatedRow = {
      productionDataName: name,
    };
    insertProductionData(updatedRow);
    onClose2();
  };

  const handleAddResourceDetail = () => {
    const newData = {
      // sno: resourceDetails.length + 1,
      emissionDetailName: newResourceDetail,
    };
    // setResourceDetails([...resourceDetails, newData]);
    setNewResourceDetail("");
    insertEmissionData(newData);
    onClose3();
    // You can call a drawer close function if you implement one
  };

  //console.log(externalEnergySources);

  //console.log(productionData);
  //console.log(resourceDetails);

  return (
    <div
      className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <div>
        <h2
          className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
            isdarkMode ? "text-white" : "text-black"
          }`}
        >
          Manual Entry Configuration
        </h2>

        <div className="flex gap-4 h-[90vh]">
          {/* External Energy Sources */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                External Energy Sources
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer()}>
                Add +
              </Button>
            }
            className={`w-2/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={externalEnergySources}
                columnDefs={externalEnergyCols}
                domLayout="normal"
                rowHeight={50}
                 onCellValueChanged={(params) => {
                  //console.log("Updated row data:", params.data);
                  insertExternalEnergy(params.data)
                }}
              />
            </div>
          </Card>

          {/* Production Data */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Production Data
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer2()}>
                Add +
              </Button>
            }
            className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={productionData}
                columnDefs={productionCols}
                domLayout="normal"
              />
            </div>
          </Card>

          {/* resource Details */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Resource Details
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer3()}>
                Add +
              </Button>
            }
            className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={resourceDetails}
                columnDefs={resourceCols}
                domLayout="normal"
              />
            </div>
          </Card>
        </div>
      </div>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form}
            name="Group-add-form"
            // className="font-bold"
            layout="horizontal"
            style={{ maxWidth: 600 }}
            labelCol={{ span: 10, offset: 0 }}
            labelAlign="left"
            onFinish={onFinish}
          >
            {/* External Source */}
            <Form.Item
              label="External Energy Sources"
              name="externalSource"
              rules={[
                {
                  required: true,
                  message: "Please enter external energy source",
                },
              ]}
            >
              <Input
                placeholder="Enter External Energy Source..."
                className={`${isdarkMode ? "darkmode-input" : ""}`}
              />
            </Form.Item>

            {/* Cost Per Unit */}
            <Form.Item
              label="Cost Per Unit"
              name="costPerUnit"
              rules={[
                { required: true, message: "Please enter cost per unit" },
              ]}
            >
              <Input
                placeholder="Enter Cost Per Unit..."
                className={`${isdarkMode ? "darkmode-input" : ""}`}
              />
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose2} className="">
              Cancel
            </Button>
            <Button
              // htmlType="submit"
              type="primary"
              //   disabled={!newProductionData.trim()}
              onClick={() => form.submit()}
            >
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer2}
        open={open2}
        onClose={onClose2}
      >
        <div className="flex flex-col gap-6 mt-2">
          <div>
            <label className="block mb-2 font-medium">
              Add Production Data
            </label>
            <Input
              placeholder="Enter Production Data.."
              value={newProductionData}
              onChange={(e) => setNewProductionData(e.target.value)}
              className={`${isdarkMode ? "darkmode-input" : ""}`}
            />
          </div>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={!newProductionData.trim()}
              onClick={handleAddProductionData}
            >
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer3}
        open={open3}
        onClose={onClose3}
      >
        <div className="flex flex-col gap-6 mt-2">
          <div>
            <label className="block mb-2 font-medium">
              Add emission factor name
            </label>
            <Input
              placeholder="Enter emission factor name.."
              value={newResourceDetail}
              onChange={(e) => setNewResourceDetail(e.target.value)}
              className={`${isdarkMode ? "darkmode-input" : ""}`}
            />
          </div>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={!newResourceDetail.trim()}
              onClick={handleAddResourceDetail}
            >
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
    </div>
  );
};

export default ManualData;
